import React, { useEffect, useRef, useState } from 'react';
import { Info } from 'lucide-react';
import { UNIFIED_ACCOUNT_INFO, UNIFIED_ACCOUNT_LABELS } from './unifiedAccountContent';
import './UnifiedAccountButton.css';

export function UnifiedAccountInfoPanel({ onClose }) {
  return (
    <div className="mb-unified-info" role="dialog" aria-labelledby="mb-unified-info-title">
      <div className="mb-unified-info__title" id="mb-unified-info-title">
        {UNIFIED_ACCOUNT_INFO.title}
      </div>
      <p className="mb-unified-info__intro">{UNIFIED_ACCOUNT_INFO.intro}</p>
      <ul className="mb-unified-info__list">
        {UNIFIED_ACCOUNT_INFO.benefits.map((item) => (
          <li key={item.title}>
            <span className="mb-unified-info__item-title">{item.title}</span>
            <span className="mb-unified-info__item-text">{item.text}</span>
          </li>
        ))}
      </ul>
      {onClose ? (
        <button type="button" className="mb-unified-info__close" onClick={onClose}>
          Понятно
        </button>
      ) : null}
    </div>
  );
}

export default function UnifiedAccountButton({
  onClick,
  href,
  disabled = false,
  loading = false,
  className = '',
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  type = 'button',
  primaryLabel = UNIFIED_ACCOUNT_LABELS.primary,
  secondaryLabel = UNIFIED_ACCOUNT_LABELS.secondary,
  showInfo = true,
}) {
  const [infoOpen, setInfoOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!infoOpen) return undefined;
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setInfoOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [infoOpen]);

  const classes = [
    'wsid-unified-btn',
    `wsid-unified-btn--${variant}`,
    `wsid-unified-btn--${size}`,
    fullWidth ? 'wsid-unified-btn--full' : '',
    loading ? 'wsid-unified-btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  const body = (
    <>
      <span className="wsid-unified-btn__main">
        <span className="wsid-unified-btn__title">{primaryLabel}</span>
        <span className="wsid-unified-btn__subtitle">{secondaryLabel}</span>
      </span>
      {showInfo ? (
        <span className="mb-unified-btn-info-wrap" ref={rootRef}>
          <button
            type="button"
            className="wsid-unified-btn__info"
            aria-label={UNIFIED_ACCOUNT_INFO.infoAriaLabel}
            aria-expanded={infoOpen}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setInfoOpen((v) => !v);
            }}
          >
            <Info size={18} aria-hidden />
          </button>
          {infoOpen ? (
            <div className="mb-unified-info-popover">
              <UnifiedAccountInfoPanel onClose={() => setInfoOpen(false)} />
            </div>
          ) : null}
        </span>
      ) : null}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        aria-disabled={disabled || loading}
        onClick={(e) => {
          if (disabled || loading) {
            e.preventDefault();
            return;
          }
          onClick?.(e);
        }}
      >
        {body}
      </a>
    );
  }

  return (
    <button type={type} className={classes} disabled={disabled || loading} onClick={onClick}>
      {body}
    </button>
  );
}
